// This file is auto-generated during build process
// Do not edit manually - it will be overwritten

export interface MicroSRPCXConfig {
  VITE_CDN_URL: string;
  VITE_CDN_ID: string;
  VITE_IMAGE_SERVICE_API: string;
  VITE_JAMS_BACKEND_URL: string;
  VITE_MUST_ENDPOINT: string;
  VITE_ASC_ENDPOINT: string;
  VITE_INVENTORY_API: string;
  NPM_TOKEN: string;
  COMPONENTS_BUCKET_NAME: string;
}

export const config: MicroSRPCXConfig = {
  VITE_CDN_URL: 'https://d3h3nxtl6rlfz4.cloudfront.net',
  VITE_CDN_ID: 'EWA0DBVP6VUNE',
  VITE_IMAGE_SERVICE_API: 'https://media-cdn-a5-jazel-tango.jazel-qa.com',
  VITE_JAMS_BACKEND_URL: 'https://wbirepr5cc.execute-api.us-west-2.amazonaws.com/prod',
  VITE_MUST_ENDPOINT: 'https://7k7769xaoe.execute-api.us-east-1.amazonaws.com',
  VITE_ASC_ENDPOINT: '',
  VITE_INVENTORY_API: 'https://25rjjq6lzc.execute-api.us-west-2.amazonaws.com/prod',
  NPM_TOKEN: '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',
  COMPONENTS_BUCKET_NAME: 'jazel-lightning-components-prod'
};

export default config;
